var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { OrganisationLogoCard } from './organisation-logo-card';
import { useInfiniteScrollArray } from '../hooks/use-infinite-scroll-array';
import { GridLoader } from '../elements/grid-loader';
var cls = classNames('market-map-grid');
export var OrganisationMarketMapGridDefaultProps = {
  items: [],
  itemsPerPage: 80,
  spacing: 4,
  backgroundColor: {
    background: 'canvas'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    align-content: flex-start;\n\n    ", "\n\n    flex: 1 0 0;\n    align-self: stretch;\n    justify-content: flex-start;\n\n    ", "\n\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    align-content: flex-start;\n\n    ", "\n\n    flex: 1 0 0;\n    align-self: stretch;\n    justify-content: flex-start;\n\n    ", "\n\n  "])), function (_a) {
    var spacing = _a.spacing;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      gap: ", ";\n    "], ["\n      gap: ", ";\n    "])), theme.UNIT(spacing));
  }, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR(backgroundColor.background));
  })
});
var ItemStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-grow: 1;\n    \n    img {\n      object-fit: contain !important;\n    }\n  "], ["\n    flex-grow: 1;\n    \n    img {\n      object-fit: contain !important;\n    }\n  "])))
});
var CardStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Card: styled(OrganisationLogoCard)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Loader: styled(GridLoader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
export var OrganisationMarketMapGrid = function (props) {
  var className = props.className,
    itemsPerPage = props.itemsPerPage,
    children = props.children,
    spacing = props.spacing,
    backgroundColor = props.backgroundColor;
  var _a = useInfiniteScrollArray({
      itemsPerPage: itemsPerPage,
      all: props.items
    }),
    items = _a.items,
    sentryRef = _a.sentryRef,
    hasNextPage = _a.hasNextPage;
  return React.createElement(My.Container, {
    spacing: spacing,
    backgroundColor: backgroundColor,
    className: cls.name(className)
  }, items.map(function (organisation, index) {
    var logo = organisation.logo;
    return React.createElement(My.Item, {
      key: organisation.id
    }, React.createElement(My.Card, {
      key: organisation.id,
      index: index / (items.length / itemsPerPage),
      entity: organisation,
      hasBorder: props.hasBorder
    }));
  }), hasNextPage && React.createElement(My.Loader, {
    ref: sentryRef
  }));
};
OrganisationMarketMapGrid.defaultProps = OrganisationMarketMapGridDefaultProps;
OrganisationMarketMapGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;